import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import changeNavSelected from '../../../../../redux/actions/changeNavSelected'
import Content from '../../lowVoltageSystems/accessControl/Content'
import PageBanner from '../../../../common/PageBanner'

const AccessControl = props => {

    useEffect(() => {
        props.changeNavSelected(2)
    }, [])

    return (
        <div className="bg-white">
            <PageBanner title='Access Control' img={{ name: 'commonBanner', type: 'jpg' }}/>
            <Content/>
        </div>
    )
}

const mapStateToProps = state => { return state }
const mapDispatchToProps = { changeNavSelected }

export default connect(mapStateToProps,mapDispatchToProps)(AccessControl)